<template>
  <div class="">
    <table class="plc-table">
      <tr class="plc-table__header">
        <th class="plc-table__headerCell hidden-sm-only">Height</th>
        <th class="plc-table__headerCell hidden-sm-only">Date</th>
        <th class="plc-table__headerCell hidden-sm-only">Transactions</th>
        <th class="plc-table__headerCell hidden-sm-only">Total sent</th>
        <th class="plc-table__headerCell hidden-sm-only">Block size</th>
      </tr>
      <blocks-history-row
        v-for="block in blocksFiltered"
        :key="block.height"
        :row="block"
        @mouseover="block.new = false"
      />
    </table>

    <gl-loader-lazy ref="gl-loader-lazy" @load-more="handlerLoadingMore" />
  </div>
</template>

<script>
import BlocksHistoryRow from './components/BlocksHistoryRow'
import GlLoaderLazy from '@gl/GlLoaderLazy'
import { getBlock, getBlockList } from '@/services/api'

export default {
  name: 'BlocksHistory',
  components: { BlocksHistoryRow, GlLoaderLazy },
  data() {
    return {
      activeRequest: false,
      blocks: [],
    }
  },
  computed: {
    blocksFiltered() {
      const type = this.$route.query.type || null
      if (type) {
        return this.blocks.filter(bl => {
          return bl.tx.find(tx => tx.type === type)
        })
      }
      return this.blocks
    },
  },
  watch: {
    async '$route.params.id'(val, oldVal) {
      if (val && val !== oldVal) {
        this.blocks = []
        this.$refs['gl-loader-lazy'].processing()
      }
    },
  },
  created() {
    this.loadBlockList()
  },
  methods: {
    async loadBlockList() {
      if (this.activeRequest) return
      this.activeRequest = true

      const blocks = []

      let id = this.blocks.length
        ? this.blocks[this.blocks.length - 1].height - 1
        : Number.parseInt('' + this.$route?.params?.id)

      if (!Number.isInteger(id)) {
        const { data } = await getBlockList(1)
        if (data.state === 'success' && data.data.length && data.data[0]?.height) {
          id = data.data[0].height
        } else {
          return
        }
      }

      const inProgress = []
      for (let i = id; i > id - 20; i -= 1) {
        inProgress.push(getBlock(i, true))
        blocks.push({ height: i, tx: [] })
      }

      const completed = await Promise.allSettled(inProgress)
      completed.forEach(i => {
        if (i.status === 'fulfilled') {
          const find = blocks.find(j => j.height === i.value.data.data.height)
          if (find) {
            Object.keys(i.value.data.data).forEach(key => (find[key] = i.value.data.data[key]))
          }
        }
      })

      blocks.sort((a, b) => b.time - a.time)

      this.blocks.push(...blocks)
      this.activeRequest = false

      return blocks.length
    },
    async handlerLoadingMore() {
      if (this.activeRequest) return

      const count = await this.loadBlockList()
      if (!count) this.$refs['gl-loader-lazy'].completed()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/blocks/table';
</style>
